/** Almanac/BR ids contain letters (`bondsba01`). MLB person ids are numeric (`545361`). */
export const isAlmanacPlayerId = (playerId) =>
  /[a-z]/i.test(String(playerId ?? "").trim());

export const sportFetchesHeadshots = (sport, playerId) => {
  if (sport === "nba" || sport === "nfl") {
    return Boolean(playerId);
  }
  return sport === "mlb" && isAlmanacPlayerId(playerId);
};

export const isMlbPersonId = (playerId) =>
  /^\d+$/.test(String(playerId ?? "").trim());

export const playerIdInitial = (playerId) => {
  const initial = String(playerId || "").charAt(0);
  return initial ? initial.toUpperCase() : "?";
};

export const serializeHeadshotIds = (ids = []) =>
  [...new Set(ids.filter(Boolean).map(String))].sort().join(",");

export const collectPlayerIds = (rows = []) =>
  [...new Set(rows.map((row) => row.playerId).filter(Boolean).map(String))];

export const getHeadshotUrl = (headshots, playerId) =>
  headshots?.[playerId]?.url || null;

export const collectHeadshotUrls = (headshots = {}) =>
  Object.values(headshots)
    .map((entry) => entry?.url)
    .filter(Boolean);

/** Cached <img> can skip onLoad after a remount; still treat it as ready to paint. */
export const headshotImgIsReady = ({
  loaded = false,
  error = false,
  complete = false,
  naturalWidth = 0,
} = {}) => {
  if (error) return false;
  if (loaded) return true;
  return Boolean(complete && naturalWidth > 0);
};

export const preloadHeadshotUrls = (urls = []) => {
  urls.filter(Boolean).forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};
